import React from 'react'

import {translate} from 'react-i18next'
import PageMessage from 'components/PageMessage'
import View from 'components/View'
import Title from 'components/Title'
import ErrorText from './ErrorText'
import ErrorLinks from './ErrorLinks'

const ErrorMessage = ({error, description, t}) => (
  <View>
    <Title>{t('errors.title')}</Title>
    <PageMessage error>
      <ErrorText error={error} description={description} />
    </PageMessage>
    <ErrorLinks />
  </View>
)

export {ErrorMessage as PureErrorMessage}

export default translate()(ErrorMessage)
